import { render, staticRenderFns } from "./AgencyProjectName.vue?vue&type=template&id=2c0eaffd&scoped=true&"
import script from "./AgencyProjectName.vue?vue&type=script&lang=js&"
export * from "./AgencyProjectName.vue?vue&type=script&lang=js&"
import style0 from "./AgencyProjectName.vue?vue&type=style&index=0&id=2c0eaffd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0eaffd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib'
installComponents(component, {VLayout})
